<template>
  <Sider
    width="200"
    class="layout-sider"
    :collapsed-width="80"
    collapsible
    v-model="collapsed"
  >
    <div class="layout-sider-logo">
      <router-link :to="{ name: 'home' }">
        <span class="layout-sider-logo-link">{{ getmember.tit }}</span>
      </router-link>
    </div>
    <div class="layout-sider-content">
      <Menu
        ref="lidaMenu"
        :active-name="activeName"
        theme="dark"
        width="auto"
        @on-select="select"
        :open-names="defaultopenNames"
        accordion
      >
        <template v-for="(it, index) in Menuitems">
          <Submenu
            v-if="'items' in it"
            :name="it.index"
            :class="collapsed ? 'collapsed' : ''"
          >
            <template slot="title">
              <Icon
                :type="it.icon"
                style="font-size: 1.5rem"
              />
              <span>{{ it.title }}</span>
            </template>
            <MenuItem
              v-for="res in it.items"
              :name="`${res.title},${res.to}`"
              :key="res.title"
            >{{ res.title }}</MenuItem>
          </Submenu>
          <MenuItem
            v-else
            :name="`${it.title},${it.to}`"
          >
          <Icon
            :type="it.icon"
            style="font-size: 1.5rem"
          />
          <span>{{ it.title }}</span>
          </MenuItem>
        </template>
      </Menu>
    </div>
  </Sider>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: 'mainSider',
  inject: ["reload"],
  props: {
    isCollapsed: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      tabsActive: "",
      tabs: []
    };
  },
  computed: {
    ...mapGetters(["getmember", 'getpermission']),
    collapsed: {
      get () {
        return this.isCollapsed
      },
      set (val) {
        this.$emit('update:isCollapsed', val)
      }
    },
    activeName () {
      const routedata = this.$route.matched[1];
      if (routedata.meta.Submenu) {
        const routedata2 = this.$route.matched[2];
        return `${routedata2.meta.title},${routedata2.name}`;
      } else {
        return `${routedata.meta.title},${routedata.name}`;
      }
    },
    defaultopenNames () {
      const routedata = this.$route.matched[1];
      if (!routedata.meta.Submenu) return [];
      return [routedata.meta.menuOpenid];
    },
    Menuitems () {
      const obj = {
        home: {
          index: "0",
          title: "首页",
          to: "home",
          icon: "md-people"
        },
        // liveshow: {
        //   index: "2",
        //   title: "現場監督(高管)",
        //   to: "liveshow",
        //   icon: "md-list-box"
        // },
        liveshowAll: {
          index: "3",
          title: "现场监督",
          to: "liveshowAll",
          icon: "md-list-box"
        },
        traderecord: {
          index: "5",
          title: "操盘纪录",
          to: "traderecord",
          icon: "ios-create"
        },
        generalLedger: {
          index: "6",
          title: "总帐",
          to: "general-ledger",
          icon: "logo-usd"
        },
        assortLedger: {
          index: "7",
          title: "分类帐",
          to: "assort-ledger",
          icon: "md-copy"
        },
        // periodManagement: {
        //   index: "8",
        //   title: "期数管理",
        //   to: "period-management",
        //   icon: "ios-bookmarks"
        // },
        // openManagement: {
        //   index: "9",
        //   title: "开奖管理",
        //   to: "open-management",
        //   icon: "ios-bookmarks-outline"
        // },
        setting: {
          index: "11",
          title: "系统设定",
          to: "setting",
          icon: "ios-construct",
          items: [
            // {
            //   title: "水位设置",
            //   to: "water-level"
            // },
            // {
            //   title: "自动跳水设定(高管)",
            //   to: "auto-diving"
            // },
            {
              title: "自动跳水设定(各站)",
              to: "auto-diving-all"
            },
            // {
            //   title: "补货设定",
            //   to: "replenishment"
            // },
            {
              title: "杂项",
              to: "miscellaneous"
            },
            {
              title: "年度生肖",
              to: "year_zodiac"
            },
            {
              title: "額外站点設定",
              to: "otherSiteList"
            },
            {
              title: "公告",
              to: "announcement"
            }
          ]
        },
        gameLobby: {
          index: "12",
          title: "游戏",
          to: "game-lobby",
          icon: "md-game-controller-b",
          items: (() => {
            let arr1 = []
            let arr2 = []
            if (this.getpermission.gameswitch[0] == 1) arr1.push({ title: "彩种总表", to: "lottery-kind" })
            if (this.getpermission.gameswitch[2] == 1) arr1.push({ title: "外站游戏", to: "electronic-games" })
            if (this.getpermission.gameset[0] == 1) arr2.push({ title: "自开彩RTP调整", to: "self-lottery-rtp" })
            if (this.getpermission.gameset[2] == 1) arr2.push({ title: "自开彩开奖设定", to: "self-lottery-draw" })
            if (this.getpermission.gameset[4] == 1) arr2.push({ title: "自开彩下注时间设定", to: "self-lottery-bet-time" })
            if (this.getpermission.settlement[0] == 1) arr2.push({ title: "日開彩結算時間设定", to: "self-lottery-daily-time" })
            const dataObj = [...arr1, ...arr2]
            if (process.env.VUE_APP_CQ9_STATE !== 'true') dataObj.splice(1, 1)
            return dataObj
          })()
        },
        operator: {
          index: "13",
          title: "操作员",
          to: "operator",
          icon: "ios-contact"
        },
        operatorGroup: {
          index: "14",
          title: "操作员组",
          to: "operator-group",
          icon: "ios-contacts"
        },
        // { title: "现金会员", to: "cash_member", icon: "ios-cash" },
        personalCenter: {
          index: "15",
          title: "个人中心",
          to: "personal-center",
          icon: "ios-person",
          items: [
            {
              title: "个人资讯",
              to: "usermsg"
            },
            {
              title: "游戏规则",
              to: "gamerule"
            },
            {
              title: "修改密码",
              to: "fixpass"
            }
          ]
        },
        websiteManagement: {
          index: "16",
          title: "网站管理",
          to: "website-management",
          icon: "md-browsers",
          items: [
            {
              title: "入口網站管理",
              to: "login-number"
            },
            {
              title: "营运站点管理",
              to: "acout",
              icon: "md-people"
            },
          ]
        }
      }
      let array = ['home', 'websiteManagement']
      // if (this.getpermission.member[0] == '1') {
      //   array.push('acout')
      // }
      if (this.getpermission.inspect[0] == '1') {
        const key = ['liveshowAll']
        array.push(...key)
      }

      if (this.getpermission.system[1] == '1') {
        array.push('traderecord')
      }
      if (this.getpermission.report[0] == '1') {
        const key = ['generalLedger', 'assortLedger']
        array.push(...key)
      }
      // if (this.getpermission.period[0] == '1') {
      //   array.push('periodManagement')
      // }
      // if (this.getpermission.lottery[0] == '1') {
      //   array.push('openManagement')
      // }
      if (this.getpermission.system[2] == '1') {
        array.push('setting')
      }
      if (this.getpermission.gameswitch[0] == '1' || this.getpermission.gameswitch[2] == '1' || this.getpermission.gameset[0] == '1' || this.getpermission.gameset[2] == '1' || this.getpermission.gameset[4] == '1') {
        array.push('gameLobby')
      }
      if (this.getpermission.operator[0] == '1') {
        array.push('operator')
      }
      if (this.getpermission.opergroup[0] == '1') {
        array.push('operatorGroup')
      }
      array.push('personalCenter')
      const items = array.map(it => obj[it])
      return items
    }
  },
  watch: {
    defaultopenNames (val) {
      this.$nextTick(() => {
        this.$refs.lidaMenu.updateOpened()
      })
    }
  },
  created () {
    this.defatlt_tabs();
  },
  methods: {
    ...mapActions(["Setnavlist"]),
    defatlt_tabs () {
      const _route = this.$route;
      this.tabs.push({ title: _route.meta.title, to: _route.name });
    },
    handleTabRemove (name) {
      const index = this.tabs.map(it => it.to).indexOf(name);
      this.tabs.splice(index, 1);
      this.tabsActive = this.tabs[0].to;
      this.changetabs(this.tabsActive);
    },
    changetabs (event) {
      this.$router.push({ name: event });
    },
    select (event) {
      let componentexist = false;
      const [title, to] = event.split(",");
      this.Setnavlist({ title, to });
      const liveshow = this.$route.name == "scode" && to == "liveshow";
      if (liveshow) {
        this.reload();
      } else {
        if (this.$route.name !== to) {
          this.$router.push({ name: to });
        } else {
          this.reload();
        }
      }
    }
  }
};
</script>

<style lang="less">
.layout-sider {
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.5);
  user-select: none;
  .ivu-menu-dark.ivu-menu-vertical .ivu-menu-opened {
    background: #395b9f;
    .ivu-menu-submenu-title {
      background: #24478d;
    }
  }
  .ivu-menu-dark.ivu-menu-vertical
    .ivu-menu-item-active:not(.ivu-menu-submenu) {
    color: #fff;
    background: #1877f2;
  }
}
.ivu-layout-sider {
  position: fixed;
  z-index: 12;
  height: 100%;
  max-width: 100%;
  left: 0;
  top: 0;
  .layout-sider-logo {
    height: 60px;
    line-height: 70px;
    text-align: center;
    border-bottom: 1px solid rgba(255, 255, 255, 0.5);
    overflow: hidden;
    .layout-sider-logo-link {
      font-family: MicrosoftJhengHei;
      font-size: 24px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: left;
      color: #fffefe;
    }
    img {
      height: 80%;
      vertical-align: middle;
    }
  }
  .layout-sider-content {
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
    overflow-y: auto;
    height: calc(100% - 60px);
    width: 100%;
    position: absolute;
    &::-webkit-scrollbar {
      width: 0 !important;
    }
  }
  .ivu-layout-sider-trigger {
    position: absolute;
    width: 16px !important;
    right: -8px;
    top: 45%;
    border: 1px solid black;
    border-radius: 4px;
    background: white;
    color: black;
    cursor: pointer !important;
  }
  .collapsed .ivu-menu-submenu-title-icon {
    display: none;
  }
}
</style>
